(() => {
  const attach = form => {
    if (form.dataset.ahtiProtection) return;
    const nativeContact = /\/contact(?:[?#]|$)/.test(form.action);
    const zohoForm = form.action.includes('crm.zoho.com/crm/WebToLeadForm');
    const catalogueForm = form.id === 'ahti-catalogue-access-form';
    if (!nativeContact && !zohoForm && !catalogueForm) return;
    const type = form.querySelector('input[name="form_type"]');
    if (nativeContact && (!type || !['contact', 'customer'].includes(type.value))) return;
    form.dataset.ahtiProtection = 'true';
    const trap = document.createElement('input');
    trap.type = 'text';
    trap.name = 'contact[ahti_website_check]';
    trap.tabIndex = -1;
    trap.autocomplete = 'off';
    trap.setAttribute('aria-hidden', 'true');
    trap.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden';
    form.append(trap);
    form.addEventListener('submit', event => {
      if (trap.value) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  };
  const scan = () => document.querySelectorAll('form').forEach(attach);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
